import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { UseTheme } from '../../hooks/useTheme'
import { UseTypeFontSize } from '../../hooks/useTypeFontSize'
import { Element } from '../element'
import { getStyle } from '../helper'
import { Style } from '../Style'
import classes from './index.module.scss'

export const Radio = ({
  title,
  value,
  activeValue,
  onChange,
  disabled,
  isCheckOnClickText,
  appendStyle,
  mlTitle,
  titleStyle,
  inputStyle,
  translateProps,
  isI18n,
  stopPropagation,
}) => {
  const typeFontSize = UseTypeFontSize()
  const theme = UseTheme()

  const onToggle = (e) => {
    stopPropagation && e.stopPropagation()
    if (disabled) return
    onChange(value)
  }

  const onClickText = (e) => {
    if (isCheckOnClickText) {
      onToggle(e)
    }
  }

  const isCheck = activeValue === value

  return (
    <Element style={appendStyle} className="dFlex alignItemsCenter">
      <Style
        className={classes.radioBox}
        pseudo="checked:before"
        attr="background-color"
        color="#2c73e8"
      >
        <input
          className={classes.radioBox}
          onClick={onToggle}
          type="radio"
          checked={isCheck}
          readOnly
          style={getStyle(
            { borderColor: isCheck ? '#2c73e8' : '#9c9c9c', ...inputStyle },
            theme,
            typeFontSize,
          )}
        />
      </Style>
      {title && (
        <Element
          elementName="span"
          style={{ marginLeft: mlTitle, ...titleStyle }}
          className={isCheckOnClickText ? 'cursorPointer' : ''}
          onClick={onClickText}
        >
          {isI18n ? <Translate value={title} {...translateProps} /> : title}
        </Element>
      )}
    </Element>
  )
}

Radio.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.node,
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  isCheckOnClickText: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  appendStyle: PropTypes.object,
  mlTitle: PropTypes.number,
  titleStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  translateProps: PropTypes.object,
  isI18n: PropTypes.bool,
  stopPropagation: PropTypes.bool,
}

Radio.defaultProps = {
  checked: false,
  isCheckOnClickText: true,
  onChange: () => {},
  disabled: false,
  mlTitle: 10,
  titleStyle: {},
  inputStyle: {},
  translateProps: {},
  isI18n: true,
  stopPropagation: true,
}
